import {
  Checkbox,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  makeStyles,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import SearchIcon from "@material-ui/icons/Search";
import axios from "axios";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Media from "react-media";
import { connect } from "react-redux";
import Alert from "react-s-alert";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import * as yup from "yup";
import { serverApi, videoUploadSize } from "../../../../../config/Keys";
import { getAllCateogryForIcons } from "../../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import {
  get_vendor_diners_tickets_issue_category,
  get_vendor_order_item_list,
} from "../../../../../store/actions/VendorUsersTicketsActions/vendorUsersTicketsActions";
import {
  addUserTicket,
  getTicketsByUserMobileNo,
} from "../../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import AlertDialogProgress from "../../../../reusableComponents/allPopupReusable/DialogProgression";
import MultipleImageUploadComponent from "../../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

const AddOpenIssuesVendor = (props) => {
  const classes = useStyles();
  //state
  const [step, setStep] = useState(1);
  const [file, setFile] = useState(null);
  const [Video, setVideo] = useState(null);
  const [mobileNo, setMobileNo] = useState();

  const onChangeMobileNo = (mobile) => {
    setMobileNo(mobile);
  };

  const fetchuserData = (e, mobileNo) => {
    if (mobileNo.length < 10) {
      Alert.error(`<h4>Please enter valid mobile number </h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      const token = props.auth.user.accessToken;

      props.getTicketsByUserMobileNo(
        token,
        "91",
        mobileNo,

        onSuccessLoadUserData
      );
    }
  };

  const onSuccessLoadUserData = (data) => {
    if (data.length > 0) {
      if (data.length > 0) {
        setState({
          ...state,
          successResponse: data,
          name: data[0].userDetails.first_name,
          user_id: data[0].userDetails._id,
        });
      } else {
        setRequestNo([]);
        Alert.error(`<h4>Cannot create ticket as dinner id not found</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    } else {
      setState({
        ...state,
        name: "",
      });
      setRequestNo([]);
      Alert.error(`<h4>Mobile number not registered</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
        zindex: 99999,
      });
    }
  };

  const [state, setState] = useState({
    selectedTypeId: "",
    category: "",
    seating_request_no: "",
    name: "",
    user_id: "",
    issueTypeId: "",
    successResponse: [],
    restaurant_video: [],
    video_url: "",
    progress: 0,
    orderItems: [],
    totalOrderItems: 0,
  });
  const handleStepChange = (e) => {
    setStep(e);
  };

  const [issueType, setIssueType] = useState([
    { id: 0, name: "Seating", status: false, _id: "60378a476fd358ce05f0a015" },
    { id: 1, name: "Ordering", status: false, _id: "60363a2f164b288a603adc4f" },
    {
      id: 2,
      name: "Scan & Pay",
      status: false,
      _id: "6036560277d1eacb1e93c192",
    },
    { id: 3, name: "Offers", status: false, _id: "60364e47ee4004a8aaa7abb5" },
    { id: 4, name: "Wallet", status: false, _id: "603656b677d1eacb1e93c195" },
    {
      id: 5,
      name: "Technical",
      status: false,
      _id: "603657a977d1eacb1e93c19c",
    },
    { id: 6, name: "Events", status: false, _id: "6036580b77d1eacb1e93c19e" },
    { id: 7, name: "Referral", status: false, _id: "603659cc77d1eacb1e93c1a7" },
    {
      id: 8,
      name: "Rating & Review",
      status: false,
      _id: "6036588977d1eacb1e93c19f",
    },
    {
      id: 9,
      name: "General/Other",
      status: false,
      _id: "6036590e77d1eacb1e93c1a5",
    },
    {
      id: 10,
      name: "Other/Payment",
      status: false,
      _id: "6036597a77d1eacb1e93c1a6",
    },
  ]);

  const onChangeIssueType = (id) => {
    formikStep1.setFieldValue("selectedIssueType", id);
    const data = [];
    for (var i = 0; i < issueType.length; i++) {
      if (id === issueType[i].id) {
        data.push({
          name: issueType[i].name,
          status: true,
          id: id,
          _id: issueType[i]._id,
        });
        formikStep1.setFieldValue("issue_type", issueType[i].name);
        setState({
          ...state,
          issueTypeId: issueType[i]._id,
          selectedTypeId: issueType[i].id,
        });
      } else {
        data.push({
          name: issueType[i].name,
          status: false,
          id: issueType[i].id,
          _id: issueType[i]._id,
        });
      }
    }
    setIssueType(data);
  };

  /*************************************
   * @DESC Multiple Image Upload
   ************************************/
  const [combined, setCombined] = React.useState("");
  const [restaurant_pictures_new, setResPicNew] = React.useState([]);
  const onCompleteUploadMultipleCrop = (e, file) => {
    let oldData = formik.values.refrence_images;
    let newData = e;
    let mergedData = oldData.concat(newData);
    formik.setFieldValue("refrence_images", mergedData);
    let restaurant_pictures_temp = restaurant_pictures_new;

    let newToUpload = restaurant_pictures_temp.filter((item, index) => {
      return item.name !== file.name;
    });
    setResPicNew(newToUpload);
  };

  const bankUploadMultipleFiles = (e) => {
    // this.setState({ bankImageLoader: true });

    if (formik.values.refrence_images.length + e.target.files.length > 6) {
      Alert.error(`<h4>Cannot upload more than 6 image</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      const vendor_id = props.auth.user.VendorUser._id;
      let restaurant_name;
      if (props.onboarding.restaurant_name) {
        restaurant_name = props.onboarding.restaurant_name.split(" ").join("");
      } else {
        restaurant_name = "";
      }
      const combined = vendor_id + "_" + restaurant_name;
      const data = new FormData();
      let flag = false;
      var newUploaded = [];
      var docs = false;
      for (let i = 0; i < e.target.files.length; i++) {
        let allPicures = formik.values.refrence_images;
        allPicures.some((phone) => {
          if (
            phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name
          ) {
            flag = true;
          }
        });
        if (!flag) {
          if (e.target.files[i].type === "application/pdf") {
            docs = true;
            data.append("files", e.target.files[i]);
          } else {
            newUploaded.push(e.target.files[i]);
          }
        }
      }
      if (!flag) {
        setResPicNew(newUploaded);
        setCombined(combined);
        if (docs) {
          axios
            .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data)
            .then((res) => {
              let oldData = formik.values.refrence_images;
              let newData = res.data;
              let mergedData = oldData.concat(newData);
              formik.setFieldValue("refrence_images", mergedData);
              Alert.success(`<h4>Image Upload Successfully</h4>`, {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
              });
            })
            .catch((err) => {
              Alert.error(`<h4>${err}</h4>`, {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
              });
            });
        }
      } else {
        Alert.error(`<h4>Can not upload the same image</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    }
  };

  const bankDocMultipleRemove = (indexId) => {
    let allImages = formik.values.refrence_images.filter((item, index) => {
      return index !== indexId;
    });
    formik.setFieldValue("refrence_images", allImages);
  };

  /*************************************
   * @DESC Multiple Video Upload
   ************************************/
  const uploadMultipleVideoFiles = (e) => {
    e.preventDefault();
    const vendor_id = props.auth.user.VendorUser._id;
    const restaurant_name = props.onboarding.restaurant_name
      .split(" ")
      .join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;
    for (let i = 0; i < e.target.files.length; i++) {
      if (e.target.files[i].size > videoUploadSize) {
        alert("File is too Big");
        return (flag = false);
      } else {
        if (state.restaurant_video && state.restaurant_video.length > 0) {
          if (state.restaurant_video[0].name === e.target.files[i].name) {
            return (flag = true);
          }
        }
        if (!flag) {
          data.append("file", e.target.files[i]);
        }
      }
    }
    var newData = e.target.files;
    if (!flag) {
      const setProgress = (percent) => {
        setState({ ...state, progress: percent });
      };
      axios
        .post(`${serverApi}/upload-assets-video`, data, {
          onUploadProgress: (progressEvent) => {
            setProgress((progressEvent.loaded / progressEvent.total) * 100);
          },
        })
        .then((res) => {
          setState({
            ...state,
            restaurant_video: newData,
            video_url: res.data,
            actionButton: true,
          });
          Alert.success(`<h4>Restaurant Video Upload Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        })
        .catch((err) => {
          Alert.error(`<h4>${err}</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        });
    } else {
      Alert.error(`<h4>Can not upload the same video</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

  const multipleVideoResetFile = (e) => {
    let video_url = state.video_url;
    let restaurant_video = state.restaurant_video;
    video_url = "";
    restaurant_video = [];
    setState({
      ...state,
      restaurant_video: restaurant_video,
      video_url: video_url,
      actionButton: true,
    });
  };

  const handleChangeCategoryAdd = (event) => {
    setState({
      ...state,
      category: event.target.value,
    });

    let seating = state.successResponse[0].dinerDetails;
    let orderingData = state.successResponse[1].orderDetails;
    let offerData = state.successResponse[2].offerDetails;
    let paymentData = state.successResponse[3].scanPayDetails;
    let eventData = state.successResponse[4].userEventDetails;
    let walletData = state.successResponse[5].walletDetails;
    let ratingReviewData = state.successResponse[6].ratingReviewDetails;

    let tempDinerData = [];
    if (event.target.value == "60378aaa6fd358ce05f0a016") {
      tempDinerData = seating.filter(
        (ele) => ele.service_type === "RESERVATION"
      );
      tempDinerData = tempDinerData.map((ele) => {
        return { diner_id: ele.diner_id };
      });
      setRequestNo(tempDinerData);
    } else if (event.target.value == "60378afc6fd358ce05f0a017") {
      tempDinerData = seating.filter(
        (ele) => ele.service_type === "SEATING" && !ele.isWalkIn
      );
      tempDinerData = tempDinerData.map((ele) => {
        return { diner_id: ele.diner_id };
      });
      setRequestNo(tempDinerData);
    } else if (event.target.value == "60378b0f6fd358ce05f0a018") {
      tempDinerData = seating.filter(
        (ele) => ele.service_type === "SEATING" && ele.isWalkIn
      );
      tempDinerData = tempDinerData.map((ele) => {
        return { diner_id: ele.diner_id };
      });
      setRequestNo(tempDinerData);
    } else if (event.target.value == "60363fef164b288a603adc51") {
      tempDinerData = orderingData.filter((ele) => ele.order_type === 1);
      tempDinerData = tempDinerData.map((ele) => {
        return { diner_id: ele.order_id };
      });
      setRequestNo(tempDinerData);
    } else if (event.target.value == "603787046fd358ce05f0a014") {
      tempDinerData = orderingData.filter((ele) => ele.order_type === 3);
      tempDinerData = tempDinerData.map((ele) => {
        return { diner_id: ele.order_id };
      });
      setRequestNo(tempDinerData);
    } else if (event.target.value == "603786966fd358ce05f0a013") {
      tempDinerData = orderingData.filter((ele) => ele.order_type === 2);
      tempDinerData = tempDinerData.map((ele) => {
        return { diner_id: ele.order_id };
      });
      setRequestNo(tempDinerData);
    } else if (event.target.value == "60363fc4164b288a603adc50") {
      tempDinerData = orderingData.filter((ele) => ele.order_type === 0);
      tempDinerData = tempDinerData.map((ele) => {
        return { diner_id: ele.order_id };
      });
      setRequestNo(tempDinerData);
    } else if (event.target.value == "60364e6cee4004a8aaa7abb7") {
      tempDinerData = offerData.filter((ele) => ele.isOnline);
      tempDinerData = tempDinerData.map((ele) => {
        return { diner_id: ele.coupon_code };
      });
      setRequestNo(tempDinerData);
    } else if (event.target.value == "60364e64ee4004a8aaa7abb6") {
      tempDinerData = offerData.filter((ele) => !ele.isOnline);
      tempDinerData = tempDinerData.map((ele) => {
        return { diner_id: ele.coupon_code };
      });
      setRequestNo(tempDinerData);
    } else if (event.target.value == "603656d977d1eacb1e93c197") {
      tempDinerData = walletData.filter((ele) => ele.t_type === 6);
      tempDinerData = tempDinerData.map((ele) => {
        return { diner_id: ele._id };
      });
      setRequestNo(tempDinerData);
    } else if (event.target.value == "6036571677d1eacb1e93c19a") {
      tempDinerData = walletData.filter((ele) => ele.t_type === 4);
      tempDinerData = tempDinerData.map((ele) => {
        return { diner_id: ele._id };
      });
      setRequestNo(tempDinerData);
    } else if (event.target.value == "603656e977d1eacb1e93c198") {
      tempDinerData = walletData.filter((ele) => ele.t_type === 3);
      tempDinerData = tempDinerData.map((ele) => {
        return { diner_id: ele._id };
      });
      setRequestNo(tempDinerData);
    } else if (event.target.value == "603656cb77d1eacb1e93c196") {
      tempDinerData = walletData.filter((ele) => ele.t_type === 2);
      tempDinerData = tempDinerData.map((ele) => {
        return { diner_id: ele._id };
      });
      setRequestNo(tempDinerData);
    } else if (event.target.value == "6036570377d1eacb1e93c199") {
      tempDinerData = walletData.filter((ele) => ele.t_type === 5);
      tempDinerData = tempDinerData.map((ele) => {
        return { diner_id: ele._id };
      });
      setRequestNo(tempDinerData);
    } else if (event.target.value == "603658c077d1eacb1e93c1a2") {
      tempDinerData = walletData.filter((ele) => ele.type === 2);
      tempDinerData = tempDinerData.map((ele) => {
        return { diner_id: ele._id };
      });
      setRequestNo(tempDinerData);
    } else if (event.target.value == "603658d077d1eacb1e93c1a4") {
      tempDinerData = walletData.filter((ele) => ele.type === 4);
      tempDinerData = tempDinerData.map((ele) => {
        return { diner_id: ele._id };
      });
      setRequestNo(tempDinerData);
    } else if (event.target.value == "603658c977d1eacb1e93c1a3") {
      tempDinerData = walletData.filter((ele) => ele.type === 3);
      tempDinerData = tempDinerData.map((ele) => {
        return { diner_id: ele._id };
      });
      setRequestNo(tempDinerData);
    } else if (event.target.value == "603658ab77d1eacb1e93c1a0") {
      tempDinerData = walletData.filter((ele) => ele.type === 0);
      tempDinerData = tempDinerData.map((ele) => {
        return { diner_id: ele._id };
      });
      setRequestNo(tempDinerData);
    } else if (event.target.value == "603658b877d1eacb1e93c1a1") {
      tempDinerData = walletData.filter((ele) => ele.type === 1);
      tempDinerData = tempDinerData.map((ele) => {
        return { diner_id: ele._id };
      });
      setRequestNo(tempDinerData);
    }

    formik.setFieldValue("category", event.target.value);
  };

  const [ShowAddIssue, setShowAddIssue] = useState(false);

  const handleShowAddIssue = () => {
    setShowAddIssue(true);
  };

  const handleCloseAddIssue = () => {
    setShowAddIssue(false);
  };

  const [category, setCategory] = useState([]);

  const onSuccessGetFavChain = (data) => {
    var cateogryIcons = [];
    for (var i = 0; i < data.length; i++) {
      cateogryIcons.push({ name: data[i].title, id: data[i]._id });
    }
    setCategory(cateogryIcons);
  };

  const [requestNo, setRequestNo] = useState([]);

  const handleSeatingRequestNo = (event) => {
    setState({
      ...state,
      seating_request_no: event.target.value,
    });
    formik.setFieldValue("seating_request_no", event.target.value);
  };

  const handleOrderItemsCall = (event) => {
    setState({
      ...state,
      seating_request_no: event.target.value,
      totalOrderItems: 0,
    });
    formik.setFieldValue("seating_request_no", event.target.value);
  };

  useEffect(() => {
    const token = props.auth.user.accessToken;
    if (state.seating_request_no !== "") {
      props.get_vendor_order_item_list(
        state.seating_request_no,
        token,
        onSuccessOrderItems
      );
    }
  }, [state.seating_request_no]);

  const onSuccessOrderItems = (data) => {
    console.log(data);
    setState({
      ...state,
      orderItems: data.order_items,
    });
  };

  const formikStep1 = useFormik({
    initialValues: {
      issue_type: "",
      selectedIssueType: "",
      mobile_number: "",
    },
    validationSchema: yup.object({
      issue_type: yup.string().required("Please select issue type"),
      mobile_number: yup.string().required("Mobile number is required"),
    }),

    onSubmit: (values) => {
      if (state.name.length === 0) {
        Alert.error(`<h4>Mobile number not registered</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
          zIndex: 99999,
        });
      }
      // else if (requestNo.length === 0) {
      //   Alert.error(`<h4>Cannot create ticket as dinner id not found</h4>`, {
      //     position: "top-right",
      //     effect: "bouncyflip",
      //     beep: true,
      //     html: true,
      //     timeout: 3000,
      //     offset: 35,
      //   });
      // }
      else {
        // let seating = state.successResponse[1].dinerDetails;
        // let orderingData = state.successResponse[2].orderDetails;
        // let offerData = state.successResponse[3].offerDetails;
        // let paymentData = state.successResponse[4].scanPayDetails;
        // let eventData = state.successResponse[5].userEventDetails;
        // let walletData = state.successResponse[6].walletDetails;
        // let ratingReviewData = state.successResponse[7].ratingReviewDetails;

        // let tempDinerData = [];
        // if (formikStep1.values.selectedIssueType === 0) {
        //   for (let i = 0; i < seating.length; i++) {
        //     tempDinerData.push({
        //       user_id: seating[i].user_id,
        //       diner_id: seating[i].diner_id,
        //     });
        //   }
        //   setRequestNo(tempDinerData);
        //   formik.setFieldValue("validate", true);
        // } else if (formikStep1.values.selectedIssueType === 2) {
        //   for (let i = 0; i < paymentData.length; i++) {
        //     tempDinerData.push({
        //       diner_id: paymentData[i]._id,
        //     });
        //   }
        //   setRequestNo(tempDinerData);
        //   formik.setFieldValue("validate", true);
        // } else if (formikStep1.values.selectedIssueType === 1) {
        //   for (let i = 0; i < orderingData.length; i++) {
        //     tempDinerData.push({
        //       diner_id: orderingData[i].order_id,
        //     });
        //   }
        //   setRequestNo(tempDinerData);
        //   formik.setFieldValue("validate", true);
        // } else if (formikStep1.values.selectedIssueType === 3) {
        //   for (let i = 0; i < offerData.length; i++) {
        //     tempDinerData.push({
        //       diner_id: offerData[i].coupon_code,
        //     });
        //   }
        //   setRequestNo(tempDinerData);
        //   formik.setFieldValue("validate", true);
        // } else if (formikStep1.values.selectedIssueType === 6) {
        //   for (let i = 0; i < eventData.length; i++) {
        //     tempDinerData.push({
        //       diner_id: eventData[i].event_request_id,
        //     });
        //   }
        //   setRequestNo(tempDinerData);
        //   formik.setFieldValue("validate", true);
        // } else if (formikStep1.values.selectedIssueType === 4) {
        //   for (let i = 0; i < walletData.length; i++) {
        //     tempDinerData.push({
        //       diner_id: walletData[i]._id,
        //     });
        //   }
        //   setRequestNo(tempDinerData);
        //   formik.setFieldValue("validate", true);
        // } else if (formikStep1.values.selectedIssueType === 8) {
        //   for (let i = 0; i < ratingReviewData.length; i++) {
        //     tempDinerData.push({
        //       diner_id: ratingReviewData[i].review_id,
        //     });
        //   }
        //   setRequestNo(tempDinerData);
        //   formik.setFieldValue("validate", true);
        // }
        props.get_vendor_diners_tickets_issue_category(
          state.issueTypeId,
          onSuccess
        );
      }
    },
  });

  const onSuccess = () => {
    handleStepChange(2);
  };

  const onClickNext = () => {
    formikStep1.handleSubmit();
  };

  const onCallBackFunc = () => {
    //  props.updateLatest();
    props.updateLatest();
    handleStepChange(1);
    formikStep1.resetForm();
    formik.resetForm();
    setState({
      selectedTypeId: "",
      category: "",
      seating_request_no: "",
      name: "",
      user_id: "",
      issueTypeId: "",
      successResponse: [],
      restaurant_video: [],
      video_url: "",
      progress: 0,
    });
    setMobileNo("");
    setFile("");
    setVideo("");
    handleCloseAddIssue();
  };
  const onErrorAddTicket = (err) => {
    Alert.error(`<h4>${err.data.message}</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  const formik = useFormik({
    initialValues: {
      validate: false,
      ticket_category: "",
      category: "",
      seating_request_no: "",
      order_request_no: "",
      offer_coupon_code: "",
      rating_review_request_no: "",
      event_request_no: "",
      wallet_request_id: "",
      transaction_request_no: "",
      description: "",
      items: [],
      refrence_images: [],
      refrence_videos: [],
      itemsDescription: "",
    },
    // validationSchema,
    validationSchema: yup.object({
      category: yup.string().required("Please select issue category"),
      seating_request_no: yup.string().when("validate", {
        is: true,
        then: yup.string().required("Please select  request number"),
      }),
      description: yup
        .string()
        .required("Description  is required")
        .min(1, "Minimum 1 Character")
        .max(512, "Maximum 512 Character"),
      //refrence_images: yup.array().min(1),
    }),

    onSubmit: (values) => {
      const token = props.auth.user.accessToken;
      values.user_id = state.user_id;
      let formData = {};
      formData.ticket_category = state.selectedTypeId;
      formData.ticket_sub_category_id = values.category;
      formData.description = values.description;
      formData.refrence_images = values.refrence_images;
      // formData.refrence_videos = values.refrence_videos;
      formData.refrence_videos = state.video_url;
      formData.user_id = values.user_id;
      formData.items = state.orderItems;
      if (state.selectedTypeId === 0) {
        formData.seating_request_no = values.seating_request_no;
      } else if (state.selectedTypeId === 2) {
        formData.transaction_request_no = values.seating_request_no;
      } else if (state.selectedTypeId === 1) {
        formData.order_request_no = values.seating_request_no;
      } else if (state.selectedTypeId === 3) {
        formData.offer_coupon_code = values.seating_request_no;
      } else if (state.selectedTypeId === 4) {
        formData.wallet_request_id = values.seating_request_no;
      } else if (state.selectedTypeId === 6) {
        formData.event_request_no = values.seating_request_no;
      } else if (state.selectedTypeId === 8) {
        formData.rating_review_request_no = values.seating_request_no;
      }
      // console.log(formData);

      props.addUserTicket(token, formData, onCallBackFunc, onErrorAddTicket);
    },
  });

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };
  useEffect(() => {
    if (formikStep1.errors && formikStep1.errors.mobile_number) {
      let mobile_number = document.getElementById("mobile_number");
      mobile_number.focus();
    } else if (formik.errors && formik.errors.category) {
      let catElement = document.getElementById("category");
      catElement.focus();
    } else if (state.selectedTypeId === 0) {
      if (formik.errors && formik.errors.seating_request_no) {
        let seatingElement = document.getElementById("seating_request_no");
        seatingElement.focus();
      }
    } else if (formik.errors && formik.errors.description) {
      let descElement = document.getElementById("description");
      descElement.focus();
    }
  }, [count]);

  useEffect(() => {
    props.getAllCateogryForIcons(onSuccessGetFavChain);
  }, []);

  const [categorynew, setCategorynew] = useState([]);
  useEffect(() => {
    setCategorynew(props.getIssueSubCategory);
  }, [props.getIssueSubCategory]);

  // const [checked, setChecked] = React.useState(false);
  // const handleChange = (event) => {
  //   setChecked(event.target.checked);
  // };

  const orderingDataResponse =
    state.successResponse[1] && state.successResponse[1].orderDetails;
  let filteredDataOrder =
    orderingDataResponse &&
    orderingDataResponse.filter(
      (item) => item.order_id === state.seating_request_no
    );

  const handleChangeChecked = (index) => (e) => {
    let orderItems = state.orderItems;
    let totalCount = state.totalOrderItems;
    orderItems[index].ticket_checked = !orderItems[index].ticket_checked;
    const { checked, type } = e.target;
    if (type === "checkbox" && checked === true) {
      console.log(totalCount++);
      setState({
        ...state,
        orderItems: orderItems,
        totalOrderItems: totalCount++,
      });
    } else {
      console.log(totalCount--);
      setState({
        ...state,
        orderItems: orderItems,
        totalOrderItems: totalCount--,
      });
    }
  };

  const onOrderingChangeHandler = (index) => (e) => {
    let orderItems = state.orderItems;
    orderItems[index].item_issue_description = e.target.value;
    setState({
      ...state,
      orderItems: orderItems,
    });
  };

  return (
    <React.Fragment>
      <Media query="(min-width: 991px)">
        <button
          type="button"
          className="btn btn-danger text-normal btn-lg rounded"
          onClick={handleShowAddIssue}
        >
          + Add Ticket
        </button>
      </Media>
      <Media query="(max-width: 992px)">
        <button
          type="button"
          className="btn btn-danger text-normal btn-xs rounded"
          onClick={handleShowAddIssue}
        >
          + Add Ticket
        </button>
      </Media>
      <Modal
        show={ShowAddIssue}
        onHide={handleCloseAddIssue}
        backdrop="static"
        keyboard={false}
        centered
        size="md"
      >
        <Modal.Header className="border-0 pb-0" closeButton>
          <Modal.Title className="f22-500">Add a Ticket</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {step === 1 && (
            <Form>
              <Row>
                <Col md={5}>
                  <FormControl className={"w-100"} variant="outlined">
                    <InputLabel htmlFor="outlined-Mobile">Mobile No</InputLabel>
                    <OutlinedInput
                      // value={mobileNo}
                      variant="outlined"
                      className={`w-100  ${
                        formikStep1.errors.mobile_number &&
                        formikStep1.touched.mobile_number
                          ? "enError"
                          : ""
                      }`}
                      name="mobile_number"
                      onChange={formikStep1.handleChange}
                      value={formikStep1.values.mobile_number}
                      onBlur={formikStep1.handleBlur}
                      isInvalid={
                        formikStep1.errors.mobile_number &&
                        formikStep1.touched.mobile_number
                      }
                      id="mobile_number"
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            onClick={(e) =>
                              fetchuserData(e, formikStep1.values.mobile_number)
                            }
                          >
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      }
                      labelWidth={80}
                    />
                    {formikStep1.errors.mobile_number &&
                    formikStep1.touched.mobile_number ? (
                      <div className="pho_14_regular text-danger">
                        {formikStep1.errors.mobile_number}
                      </div>
                    ) : null}
                  </FormControl>
                </Col>
                <Col md={7}>
                  <div className="row">
                    <Col md={10}>
                      <Form.Group>
                        <TextField
                          disabled
                          variant="outlined"
                          label="Name"
                          className="w-100"
                          value={state.name}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={2} className="p-0 pt-2">
                      {props.auth.loader ? (
                        <Loader
                          type="Puff"
                          color="#00BFFF"
                          height={25}
                          width={25}
                        />
                      ) : (
                        ""
                      )}
                    </Col>
                  </div>
                </Col>
                <Col md={12}>
                  <Form.Label className="f12-500 pb-3">Select Type</Form.Label>
                  <Row className="enSelectTypeIssue">
                    {issueType.map((item, index) => (
                      <Col xs={4} key={index}>
                        <div className="enCheckWithText">
                          <input
                            type="radio"
                            checked={item.status}
                            name="enIssueType"
                            onChange={(e) =>
                              state.name === ""
                                ? Alert.error(
                                    `<h4>Please enter mobile number</h4>`,
                                    {
                                      position: "top-right",
                                      effect: "bouncyflip",
                                      beep: true,
                                      html: true,
                                      timeout: 3000,
                                      offset: 35,
                                      zindex: 99999,
                                    }
                                  )
                                : onChangeIssueType(item.id)
                            }
                          />
                          <label>{item.name}</label>
                        </div>
                      </Col>
                    ))}
                  </Row>
                  {formikStep1.errors.issue_type &&
                  formikStep1.touched.issue_type ? (
                    <div className="pho_14_regular text-danger">
                      {formikStep1.errors.issue_type}
                    </div>
                  ) : null}
                  <div className="pt-4 d-flex align-items-center">
                    <Button
                      variant="outline-secondary"
                      className="btn-lg mr-4 px-5 "
                      onClick={handleCloseAddIssue}
                    >
                      Back
                    </Button>
                    <Button
                      variant={
                        state.name === "" || state.issueTypeId === ""
                          ? "outlined"
                          : "danger"
                      }
                      className="btn-lg px-5 border"
                      //onClick={(e) => handleStepChange(2)}
                      onClick={(e) => (state.name === "" ? "" : onClickNext())}
                    >
                      Next
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}
          {step === 2 && (
            <Form>
              <Row>
                <Col md={12}>
                  <div className="f12-400 opacity5 mb-3">
                    Please select the type of ticket first to continue
                  </div>
                  <Form.Group>
                    <TextField
                      variant="outlined"
                      label="Issue Type"
                      className="w-100"
                      name="issue_type"
                      disabled
                      value={formikStep1.values.issue_type}
                    />
                  </Form.Group>
                  <Form.Group>
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <InputLabel htmlFor="outlined-Issue-Category">
                        Issue Category
                      </InputLabel>
                      <Select
                        id="category"
                        value={state.category}
                        onChange={handleChangeCategoryAdd}
                        label="Issue Category"
                        inputProps={{
                          name: "category",
                          id: "outlined-Issue-Category",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                        className={`w-100 ${
                          formik.errors.category && formik.touched.category
                            ? "enError"
                            : ""
                        }`}
                      >
                        {categorynew.map((item, index) => (
                          <MenuItem
                            label={item.title}
                            value={item._id}
                            key={index}
                          >
                            {item.title}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {formik.errors.category && formik.touched.category ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.category}
                      </div>
                    ) : null}
                  </Form.Group>
                  {state.selectedTypeId === 0 ||
                  state.selectedTypeId === 1 ||
                  state.selectedTypeId === 2 ||
                  state.selectedTypeId === 3 ||
                  state.selectedTypeId === 4 ||
                  state.selectedTypeId === 6 ||
                  state.selectedTypeId === 8 ? (
                    <Form.Group>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                      >
                        <InputLabel htmlFor="outlined-Issue-Category">
                          Request Number
                        </InputLabel>
                        <Select
                          id="seating_request_no"
                          value={state.seating_request_no}
                          onChange={
                            state.selectedTypeId === 1
                              ? handleOrderItemsCall
                              : handleSeatingRequestNo
                          }
                          label="Request Number"
                          inputProps={{
                            name: "seating_request_no",
                            id: "outlined-Issue-Category",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                          className={`w-100 ${
                            formik.errors.seating_request_no &&
                            formik.touched.seating_request_no
                              ? "enError"
                              : ""
                          }`}
                        >
                          {requestNo.map((item, index) => (
                            <MenuItem
                              label={item.diner_id}
                              value={item.diner_id}
                              key={index}
                            >
                              {item.diner_id}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      {formik.errors.seating_request_no &&
                      formik.touched.seating_request_no ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.seating_request_no}
                        </div>
                      ) : null}
                    </Form.Group>
                  ) : null}

                  {state.selectedTypeId === 1 ? (
                    <React.Fragment>
                      {state && state.orderItems === [] ? (
                        ""
                      ) : (
                        <div className="row mb-4">
                          <div className="col-8">
                            <h5 className="f14-500">
                              Selected Items from the order
                            </h5>
                            <h6
                              className="f10-400 mt-2"
                              style={{ color: "#212121" }}
                            >
                              Please write separate comment for each item or you
                              can write a summary at the end
                            </h6>
                          </div>
                          <div className="col-4 text-right">
                            <p className="f10-400 text-gray">
                              Items Reported :{" "}
                              <span className="text-red">
                                {state.totalOrderItems}
                              </span>
                            </p>
                          </div>
                        </div>
                      )}
                      {state.orderItems &&
                        state.orderItems.map((items, index) => {
                          return (
                            <div className="row" key={index}>
                              {console.log(items)}
                              <div className="col-1">
                                <Checkbox
                                  checked={
                                    items && items.ticket_checked === true
                                      ? true
                                      : false
                                  }
                                  onChange={handleChangeChecked(index)}
                                  inputProps={{
                                    "aria-label": "primary checkbox",
                                  }}
                                  className="p-0"
                                />
                              </div>
                              <div className="col-8">
                                <div className="row">
                                  <div className="col-3">
                                    <SimpleReactLightbox>
                                      <SRLWrapper options={options}>
                                        <img
                                          src={
                                            items &&
                                            items.item &&
                                            items.item.images[0]
                                          }
                                          className="img-fluid"
                                          style={{
                                            width: "100%",
                                            height: "auto",
                                          }}
                                        />
                                      </SRLWrapper>
                                    </SimpleReactLightbox>
                                  </div>
                                  <div className="col-9">
                                    <div className="d-flex align-items-center">
                                      <img
                                        src={
                                          items && items.item && items.item.veg
                                            ? require("../../../../../assets/images/UserManagement/veg.svg")
                                            : require("../../../../../assets/images/UserManagement/nonveg.svg")
                                        }
                                        className="img-fluid"
                                        style={{ width: 15, height: 10 }}
                                      />
                                      <p className="f12-500 ml-2">
                                        {items && items.item && items.item.name}
                                      </p>
                                    </div>
                                    <div className="d-flex align-items-center mt-2">
                                      <i
                                        className="fa fa-inr text-red"
                                        aria-hidden="true"
                                        style={{
                                          fontSize: 12,
                                          fontWeight: "bold",
                                        }}
                                      ></i>
                                      <p className="f10-700 ml-1">
                                        {items &&
                                          items.size &&
                                          items.size.price}
                                      </p>
                                      <div className="f10-700 ml-2 mr-2">|</div>
                                      <p className="f10-400 text-gray">
                                        {items &&
                                          items.size &&
                                          items.size.description}
                                      </p>
                                    </div>
                                    <div className="f10-400 text-red mt-2 mb-2">
                                      {items && items.customised
                                        ? "Customized"
                                        : ""}
                                    </div>
                                    <div>
                                      {/* <p className="f10-400 text-gray">
                                        Crust: New Hand Tossed
                                      </p> */}
                                      {items &&
                                      items.addOns !== null &&
                                      items &&
                                      items.addOns !== undefined ? (
                                        <p className="f10-400 text-gray">
                                          Add On:{" "}
                                          {items &&
                                            items.addOns &&
                                            items.addOns.map((data, index) => {
                                              return (
                                                <React.Fragment key={index}>
                                                  {data &&
                                                    data.options &&
                                                    data.options.map(
                                                      (addOns, index) => {
                                                        return (
                                                          <React.Fragment
                                                            key={index}
                                                          >
                                                            {addOns &&
                                                              addOns.name}
                                                            ,{" "}
                                                          </React.Fragment>
                                                        );
                                                      }
                                                    )}
                                                </React.Fragment>
                                              );
                                            })}
                                        </p>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-2 text-right">
                                <p className="f10-700">
                                  x
                                  <span className="text-red">
                                    {items.quantity}
                                  </span>
                                </p>
                              </div>
                              {items && items.ticket_checked ? (
                                <div className="col-12 mt-3">
                                  <TextField
                                    id="itemsDescription"
                                    variant="outlined"
                                    label="Item Issue Description - 50 Characters"
                                    multiline
                                    rows="5"
                                    className={`w-100  ${
                                      formik.errors.itemsDescription &&
                                      formik.touched.itemsDescription
                                        ? "enError"
                                        : ""
                                    }`}
                                    name="itemsDescription"
                                    onChange={onOrderingChangeHandler(index)}
                                    value={
                                      items && items.item_issue_description
                                    }
                                    onBlur={formik.handleBlur}
                                    //onInvalid={formik.errors.email && formik.touched.email}
                                    isInvalid={
                                      formik.errors.itemsDescription &&
                                      formik.touched.itemsDescription
                                    }
                                  />
                                  {formik.errors.itemsDescription &&
                                  formik.touched.itemsDescription ? (
                                    <div className="pho_14_regular text-danger">
                                      {formik.errors.itemsDescription}
                                    </div>
                                  ) : null}
                                  <hr className="mt-4 mb-4" />
                                </div>
                              ) : null}
                            </div>
                          );
                        })}
                    </React.Fragment>
                  ) : null}

                  <Form.Group>
                    <TextField
                      id="description"
                      variant="outlined"
                      label="Issue Details"
                      multiline
                      rows="5"
                      className={`w-100  ${
                        formik.errors.description && formik.touched.description
                          ? "enError"
                          : ""
                      }`}
                      name="description"
                      onChange={formik.handleChange}
                      value={formik.values.description}
                      onBlur={formik.handleBlur}
                      //onInvalid={formik.errors.email && formik.touched.email}
                      isInvalid={
                        formik.errors.description && formik.touched.description
                      }
                    />
                    {formik.errors.description && formik.touched.description ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.description}
                      </div>
                    ) : null}
                  </Form.Group>
                  <Form.Group>
                    <SimpleReactLightbox>
                      <MultipleImageUploadComponent
                        title="Upload Images"
                        smallTitle="(You can upload only 6 pic per ticket 700 x 420 pixels)"
                        onChange={bankUploadMultipleFiles}
                        //stateValue={bank_informaion}
                        stateValue={formik.values.refrence_images}
                        newUploaded={
                          restaurant_pictures_new ? restaurant_pictures_new : []
                        }
                        combined={combined}
                        onCompleteUploadMultipleCrop={
                          onCompleteUploadMultipleCrop
                        }
                        removeImage={bankDocMultipleRemove}
                        accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
                        // loader={state.bankImageLoader}
                      />
                    </SimpleReactLightbox>
                    {formik.errors.refrence_images &&
                    formik.touched.refrence_images ? (
                      <div className="mb-3 pho_14_regular text-danger">
                        {formik.errors.refrence_images ===
                        "refrence_images field must have at least 1 items"
                          ? "refrence images field must have at least 1 items"
                          : ""}
                      </div>
                    ) : (
                      <div className="mb-3"> </div>
                    )}
                  </Form.Group>
                  <Form.Group>
                    <div className="event-offer-image">
                      <SimpleReactLightbox>
                        <MultipleImageUploadComponent
                          title="Add Video"
                          // smallTitle="( Add Videos or 360 view of Business Establishment - If needed you can get a professional photo shoot or video to make it attractive - this will appear on user app)"
                          onChange={uploadMultipleVideoFiles}
                          stateValue={
                            state.video_url === "" ? [] : [state.video_url]
                          }
                          removeImage={multipleVideoResetFile}
                          accept="video/*"
                          singleUpload={true}
                          videoUpload={true}
                          // loader={state.multipleImageLoader}
                        />
                        <div className="font_12_r c_gray mb-4 d-flex">
                          (You can upload only 1 pic per offer 700 x 420 pixels)
                        </div>
                      </SimpleReactLightbox>
                      {!state.progress && state.progress === 0 ? null : (
                        <AlertDialogProgress
                          progress={state.progress}
                          title="Video Uploading..."
                        />
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <div className="pt-4 d-flex align-items-center">
                    <Button
                      variant="outline-secondary"
                      className="btn-lg mr-4 px-5 "
                      onClick={(e) => handleStepChange(1)}
                    >
                      Back
                    </Button>
                    <Button
                      variant="danger"
                      className="btn-lg px-5"
                      onClick={() => onClickSave()}
                    >
                      Save
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

AddOpenIssuesVendor.propTypes = {
  auth: PropTypes.object.isRequired,
  getAllCateogryForIcons: PropTypes.func.isRequired,
  getTicketsByUserMobileNo: PropTypes.func.isRequired,
  addUserTicket: PropTypes.func.isRequired,
  get_vendor_diners_tickets_issue_category: PropTypes.func.isRequired,
  get_vendor_order_item_list: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  getIssueSubCategory: state.vendorUsersTickets.vendor_get_issues_category,
  //get Ticket Result
  getSeatingIssuesTicket: state.vendorUsersTickets.user_seating_issue_ticket,
  getOrderIssuesTicket: state.vendorUsersTickets.user_orders_issue_ticket,
  getOffersIssuesTicket: state.vendorUsersTickets.user_offers_issue_ticket,
  getScanPayIssuesTicket: state.vendorUsersTickets.user_scanpay_issue_ticket,
  getEventIssuesTicket: state.vendorUsersTickets.user_event_issue_ticket,
  getWalletIssuesTicket: state.vendorUsersTickets.user_wallet_issue_ticket,
  getRatingReviewIssuesTicket:
    state.vendorUsersTickets.user_ratingreview_issue_ticket,
  //Get Perticular Items List
  getOrderItemList: state.vendorUsersTickets.get_order_item_list,
});

export default connect(mapStateToProps, {
  getAllCateogryForIcons,
  getTicketsByUserMobileNo,
  addUserTicket,
  get_vendor_diners_tickets_issue_category,
  get_vendor_order_item_list,
})(AddOpenIssuesVendor);
